import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import _ from 'lodash';

import Modal from '../../../../../core/components/modal-with-input';
import { UPDATE_PARTICIPANTS_NUMBER } from './graphql';

const schema = yup
  .number()
  .integer('Cap must be an integer')
  .positive('Cap must be a positive number')
  .typeError('Cap must be a positive number');

const CapResponsesModal = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    projectId,
    segmentId,
    audienceParticipants,
  } = props;

  const [updateParticipantsNumber] = useMutation(UPDATE_PARTICIPANTS_NUMBER);
  const [value, setValue] = useState(audienceParticipants);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const handleValueChange = (newValue) => {
    setError(null);
    setValue(newValue);

    schema.validate(newValue)
      .catch((err) => {
        setError(err.message);
      });
  };

  const handleInputChange = (event, { value: newValue }) => {
    handleValueChange(newValue);
  };

  const handleSubmit = async () => {
    if (error) {
      return;
    }

    setLoading(true);
    const participantsNumber = parseInt(value, 10);

    try {
      if (value > 0) {
        await updateParticipantsNumber({
          variables: {
            projectId,
            segmentId,
            participantsNumber,
            rememberCard: false,
          },
        });
      }
      onSubmit();
      setLoading(false);
    } catch (err) {
      const graphQLError = _.first(err.graphQLErrors);
      const message = graphQLError ? graphQLError.message : err.message;

      setError(message);
      setLoading(false);
    }
  };

  useEffect(() => {
    // When opened, reset current value
    if (open) {
      handleValueChange(audienceParticipants);
    }
  }, [open]);

  return (
    <Modal
      label="Response Cap"
      buttonText="Update"
      open={open}
      onClose={onClose}
      onInputChange={handleInputChange}
      value={value}
      error={error}
      loading={loading}
      submit={handleSubmit}
    />
  );
};

CapResponsesModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string.isRequired,
  audienceParticipants: PropTypes.number.isRequired,
};

CapResponsesModal.defaultProps = {
  open: false,
};

export default CapResponsesModal;
